import"./backdrop-dialog.37ba46c3e019.js";

export class CareQuality {
  constructor() {
    document.addEventListener("click", (e) => {
      if (e.target.closest(".tqc-care-quality")) {
        document.getElementById("care-quality-modal")?.showModal();
      }
    });
  }
}
